import { Button, Col, Row } from "react-bootstrap";


function BtnRetour({
    retourAccueil,
    textBTNRetour = 'Retour',
}
) {

    return (
        <>
            <Row className="text-center">
                <Col>
                    <Button onClick={retourAccueil} className="custom-btn-retour">{textBTNRetour}</Button>
                </Col>
            </Row>
        </>
    )
}

export default BtnRetour;